const ReportTemplateEndpoint = {
  SAVE: '/cmms/report-template/save',
  REMOVE: '/cmms/report-template/remove',
  LIST: '/cmms/report-template/list',
  GET: '/cmms/report-template/get',
  GET_OVERVIEW: '/cmms/report-template/get-overview',
};

export default ReportTemplateEndpoint;
